export default function SignatureMeaning() {
  const pillars = [
    {
      icon: 'ri-user-heart-line',
      letter: 'S',
      title: 'Named Provider Relationship',
      desc: "You're assigned a provider who knows your history and health journey — not whoever happens to be available.",
    },
    {
      icon: 'ri-file-list-3-line',
      letter: 'I',
      title: 'Documented Care Standard',
      desc: 'Every visit and interaction follows a consistent, high-quality protocol tailored specifically to you.',
    },
    {
      icon: 'ri-fingerprint-line',
      letter: 'G',
      title: 'Personalized Medical Footprint',
      desc: 'Your unique health profile guides every clinical decision and personalized recommendation.',
    },
    {
      icon: 'ri-flashlight-line',
      letter: 'N',
      title: 'Direct Access Experience',
      desc: 'Reach your care team directly via secure text — real humans, real responses when you need them.',
    },
  ];

  return (
    <section id="signature" className="py-24 lg:py-32 bg-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-teal-600 mb-4">
              The Signature Standard
            </span>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-bold text-[#0F1C2E] leading-tight mb-6">
              What <em className="not-italic text-teal-600">"SIGNATURE™"</em> Means
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed">
              Every patient receives a personalized standard of care that most clinics simply can't offer — because we refuse to treat you like a number.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-lg flex-shrink-0">
                <i className="ri-double-quotes-l text-teal-600 text-xl"></i>
              </div>
              <p className="text-[#0F1C2E] text-base leading-relaxed font-medium">
                No shortcuts. No rushed visits. No insurance-driven decisions.<br />
                <span className="text-gray-500 font-normal mt-2 block">Just medicine the way it should be.</span>
              </p>
            </div>
          </div>
        </div>

        {/* Pillars grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p) => (
            <div
              key={p.letter}
              className="group bg-white rounded-2xl p-7 border border-gray-100 hover:border-teal-200 hover:-translate-y-1 transition-all duration-300 cursor-default"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-11 h-11 flex items-center justify-center bg-teal-50 group-hover:bg-teal-600 rounded-xl transition-colors duration-300">
                  <i className={`${p.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <span className="font-serif-display text-5xl font-bold text-gray-100 group-hover:text-teal-50 transition-colors duration-300 leading-none">
                  {p.letter}
                </span>
              </div>
              <h3 className="text-base font-bold text-[#0F1C2E] mb-3 leading-tight">
                {p.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Image strip */}
        <div className="mt-16 rounded-2xl overflow-hidden relative h-52 sm:h-72">
          <img
            src="https://public.readdy.ai/ai/img_res/6992139899530f51887861a3974bb36b.jpg confident medical team of doctors in white coats inside a luxurious modern Las Vegas healthcare clinic with floor to ceiling panoramic windows showing Las Vegas Strip skyline and Nevada desert mountains in background warm golden natural light elegant upscale interior contemporary high-end clinic&width=1200&height=400&seq=signature-team-vegas-mc&orientation=landscape"
            alt="Med-Care Signature Team"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A2818]/70 to-transparent flex items-center px-10 lg:px-16">
            <div>
              <p className="text-white/70 text-sm font-medium mb-1 uppercase tracking-widest">Nevada&apos;s Most Distinctive</p>
              <p className="font-serif-display text-white text-2xl sm:text-3xl font-bold">Medical Membership</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
